import { Wrench, Shield } from 'lucide-react'
import { useAuth } from '../auth'

export function LoginPage() {
  const { login } = useAuth()

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <Wrench size={64} />
        </div>
        <h1>CxRunner</h1>
        <p className="login-app-name">Commissioning Management Platform</p>

        <p>Sign in with your organizational account to manage commissioning projects, checklists, and issues.</p>

        <button className="btn btn-microsoft" onClick={login}>
          <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in with Microsoft
        </button>

        <div className="gcc-high-notice">
          <Shield size={14} />
          <span>Protected by Microsoft Entra ID (GCC High)</span>
        </div>

        <div className="login-footer">
          <div className="login-footer-links">
            <a href="https://insynergyeng.com" target="_blank" rel="noopener noreferrer">
              InSynergy Engineering
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
